import { Address } from "../../domain";
import {
  AddressRemoteDataSourceError,
  Endpoints,
  RemoteDataSource,
} from "../core";

export class AddressRemoteDataSource extends RemoteDataSource {
  public async list(): Promise<Address[]> {
    try {
      const res = await this.get(Endpoints.listAddress);
      return res.data.map((json: any) => new Address().deserialize(json));
    } catch (error) {
      if (!error.response) throw AddressRemoteDataSourceError.networkError();
      throw AddressRemoteDataSourceError.serverError();
    }
  }

  public async add(
    state: string,
    city: string,
    address: string,
    zipCode?: string
  ): Promise<null> {
    try {
      await this.post(Endpoints.addAddress, {
        body: {
          state,
          city,
          address,
          zip_code: zipCode === undefined ? "" : zipCode,
        },
      });
      return null;
    } catch (error) {
      if (!error.response) throw AddressRemoteDataSourceError.networkError();
      throw AddressRemoteDataSourceError.serverError();
    }
  }

  public async edit(
    id: number,
    state?: string,
    city?: string,
    address?: string,
    zipCode?: string
  ): Promise<null> {
    try {
      await this.post(Endpoints.editAddress, {
        body: {
          id,
          state: state === undefined ? "" : state,
          city: city === undefined ? "" : city,
          address: address === undefined ? "" : address,
          zip_code: zipCode === undefined ? "" : zipCode,
        },
      });
      return null;
    } catch (error) {
      if (!error.response) throw AddressRemoteDataSourceError.networkError();
      throw AddressRemoteDataSourceError.serverError();
    }
  }

  public async remove(id: number): Promise<null> {
    try {
      await this.post(Endpoints.removeAddress, { body: { id } });
      return null;
    } catch (error) {
      if (!error.response) throw AddressRemoteDataSourceError.networkError();
      throw AddressRemoteDataSourceError.serverError();
    }
  }
}
